import SolicitacaoChatApi from '@/Apis/Agendamento/Services/SolicitacaoChatApi'
import { ConfigUsuario } from '@/types/core'
import { Convenio, Medico } from '@/types/_'
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import { SolicitacaoChatStatusMensagemEnum } from '@/types/interfaces/solicitacao-chat/solicitacao-chat-status-mensagem.enum'
import EventBus from '@/plugins/EventBus'
import { getUser } from '@/utils/common'
import { ISolicitacaoChatFilter } from '../../../types/interfaces/solicitacao-chat/solicitacao-chat-filter.interface'
// eslint-disable-next-line import/no-useless-path-segments
import { ISolicitacaoChatList } from '../../../types/interfaces/solicitacao-chat/solicitacao-chat-list.interface'
// eslint-disable-next-line import/no-useless-path-segments
import { Hospital } from './../../../types/interfaces/SolicitacaoCirurgia'
import { IPaginator } from '../types/paginator.interface'
import { SolicitacaoChatAreaResponsavelEnum } from '../../../types/interfaces/solicitacao-chat/solicitacao-chat-area-responsavel.enum'

@Module({ namespaced: true, name: 'BackofficeChatStore' })
export default class BackofficeChatStore extends VuexModule {
  private configUserService: ConfigUsuario.IConfigUsuario = new ConfigUsuario.ConfigUsuario()
  // v-if="$user.profile.roles && $user.profile.roles.length > 0 && $user.profile.roles.includes('backoffice-chat-agendamento')"
  get permission() {
    if (getUser().profile.roles && getUser().profile.roles.length > 0 && getUser().profile.roles.includes('backoffice-chat-autorizacao')) {
      return 'autorizacao'
    }
    return 'agendamento'
  }

  activeTab: 'agendamento' | 'autorizacao' = this.permission

  filter: IBackofficeChatStoreFilter = {
    pacienteNome: '',
    numeroAgendamento: '',
    medicoIds: [],
    hospitalIds: [],
    convenioNome: [],
    allData: false,
  }

  paginator: IPaginator = {
    total: 0,
    page: 1,
    pageLength: 100,
    get pageNumbers() { return Math.ceil(this.total / this.pageLength) },
  }

  // Chat data
  scheduleChats: ISolicitacaoChatList[] = []
  authorizationChats: ISolicitacaoChatList[] = []

  // Filter data
  doctors: Medico[] = []
  hospitals: Hospital[] = []
  healthInsurances: Convenio[] = []
  chatOptions = [{ name: 'Em andamento', value: false }, { name: 'Todos', value: true }]

  @Action
  init(userId: string) {
    this.loadFilterData(userId)
  }

  @Action
  async loadChats() {
    EventBus.$emit('setLoadingRequest', { status: '', text: 'Carregando...' })

    // eslint-disable-next-line default-case
    switch (this.activeTab) {
      case 'agendamento':
        this.context.commit('setScheduleChats', [])
        await this.loadScheduleChats()
        break

      case 'autorizacao':
        this.context.commit('setAuthorizationChats', [])
        await this.loadAuthorizationChats()
        break
    }

    EventBus.$emit('clearLoadingRequest')
  }

  @Action({ commit: 'setScheduleChats' })
  async loadScheduleChats() {
    const filter = await this.context.dispatch('createFilterToRequest', SolicitacaoChatAreaResponsavelEnum.agendamento)

    const res = await SolicitacaoChatApi.listAllBackofficeChat(filter)

    if (res.success) {
      this.paginator.total = res.data.total
      return res.data.solicitacoes
    }

    return []
  }

  @Action({ commit: 'setAuthorizationChats' })
  async loadAuthorizationChats() {
    const filter = await this.context.dispatch('createFilterToRequest', SolicitacaoChatAreaResponsavelEnum.autorizacao)

    const res = await SolicitacaoChatApi.listAllBackofficeChat(filter)

    if (res.success) {
      this.paginator.total = res.data.total
      return res.data.solicitacoes
    }

    return []
  }

  @Action
  async createFilterToRequest(channel: string) {
    const { pacienteNome, numeroAgendamento, medicoIds, hospitalIds, convenioNome, allData } = this.filter
    const pagina = this.paginator.page
    const qtdPorPagina = this.paginator.pageLength

    // chatFinalizado == null (get all data)
    // chatFinalizado == false (just the opened chats)
    // chatFinalizado == true (just the finished chats)
    // eslint-disable-next-line
    let chatFinalizado: boolean | null = null

    if (!allData) {
      chatFinalizado = false
    }

    const filter: ISolicitacaoChatFilter = {
      pacienteNome: pacienteNome || '',
      numeroAgendamento: numeroAgendamento || '',
      medicoIds,
      hospitalIds,
      convenioNome,
      areaResponsavel: channel,
      chatFinalizado,
      pagina,
      qtdPorPagina,
    }

    // Fix temporary problem that api doen't accept null in query string parameters
    if (filter.chatFinalizado == null) {
      delete filter.chatFinalizado
    }

    return filter
  }

  @Action
  async loadFilterData(userId: string) {
    const promises: Promise<any>[] = []
    promises.push(this.configUserService.getAllMedicoByUsuarioId(userId))
    promises.push(this.configUserService.getHospitalCurrentUser())
    promises.push(this.configUserService.getAllConveniosByUsuarioHospitalLogado())

    const [doctorsReq, hospitalReq, healthInsuranceReq] = await Promise.all(promises)

    if (doctorsReq.success) this.context.commit('setDoctors', doctorsReq.data)
    if (hospitalReq.success) this.context.commit('setHospitals', hospitalReq.data)
    if (healthInsuranceReq.success) this.context.commit('setHealthInsurances', healthInsuranceReq.data)
  }

  @Mutation
  setActiveTab(value: 'agendamento' | 'autorizacao') {
    this.activeTab = value
  }

  @Mutation
  setScheduleChats(value: ISolicitacaoChatList[]) {
    this.scheduleChats = value
  }

  @Mutation
  setAuthorizationChats(value: ISolicitacaoChatList[]) {
    this.authorizationChats = value
  }

  @Mutation
  setFilter(value: IBackofficeChatStoreFilter) {
    this.filter = value
  }

  @Mutation
  setPaginator(value: IPaginator) {
    this.paginator = value
  }

  @Mutation
  setDoctors(value: Medico[]) {
    this.doctors = value
  }

  @Mutation
  setHospitals(value: Hospital[]) {
    this.hospitals = value
  }

  @Mutation
  setHealthInsurances(value: Convenio[]) {
    this.healthInsurances = value
  }

  @Action
  resetPaginator() {
    this.context.commit('setPaginator', {
      total: 0,
      page: 1,
      pageLength: 100,
      get pageNumbers() { return Math.ceil(this.total / this.pageLength) },
    })
  }

  @Action
  resetFilter() {
    this.context.commit('setFilter', {
      pacienteNome: '',
      numeroAgendamento: '',
      medicoIds: [],
      hospitalIds: [],
      convenioIds: [],
      statusMensagem: '',
      areaResponsavel: '',
      allData: false,
    })
  }

  @Action
  reset() {
    this.context.commit('setActiveTab', 'agendamento')
    this.context.dispatch('resetFilter')
    this.context.dispatch('resetPaginator')
    this.context.commit('setDoctors', [])
    this.context.commit('setHospitals', [])
  }
}

interface IBackofficeChatStoreFilter {
  pacienteNome: string;
  numeroAgendamento: string;
  medicoIds: string[];
  hospitalIds: string[];
  convenioNome: string[];
  allData: boolean;
}
